// Helper App Badging API (angka belum-dibaca di ikon PWA terpasang).
// `navigator.setAppBadge(n)` / `clearAppBadge()` — didukung PWA terpasang di
// Chrome/Edge desktop, Android, dan iOS 16.4+ (saat dibuka dari ikon Layar Utama).
// Aman dipanggil di mana saja: no-op bila API tak tersedia.
//
// Inti logika murni (`normalizeBadgeCount`) dipisah agar bisa diuji tanpa DOM.

/** Bulatkan & clamp hitungan badge ke integer ≥ 0 (NaN/negatif → 0). */
export function normalizeBadgeCount(count: number): number {
  if (!Number.isFinite(count)) return 0;
  return Math.max(0, Math.floor(count));
}

type BadgeNavigator = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

/** True bila peramban/PWA mendukung Badging API. */
export function isAppBadgeSupported(): boolean {
  return typeof navigator !== "undefined" && "setAppBadge" in navigator;
}

/**
 * Setel angka badge ikon aplikasi ke `count` (0 = bersihkan badge). Best-effort:
 * tak pernah throw; no-op pada peramban tanpa dukungan.
 */
export function applyAppBadge(count: number): void {
  if (!isAppBadgeSupported()) return;
  const nav = navigator as BadgeNavigator;
  const n = normalizeBadgeCount(count);
  try {
    if (n > 0) void nav.setAppBadge?.(n);
    else void nav.clearAppBadge?.();
  } catch {
    // abaikan — fitur kosmetik opsional
  }
}
